import { useGiftWrapContext } from '../../context/GiftWrapContext';
import { useLocale } from '../../context/LocaleContext';

export function useViewModel() {
  const { giftInfo, setGiftInfo } = useGiftWrapContext();
  const { formatPrice } = useLocale();
  const onClose = () => {
    setGiftInfo(null);
  };

  return {
    giftInfo,
    onClose,
    formatPrice
  };
}
